import * as React from "react";

export default (props: { children: any, isLoading: boolean, className?: string, childClassName?: string }) => {
    return (
        <div className={props.className || ""}>
            <div className={props.childClassName || ""}>
                {props.children}
            </div>
            <div className={props.isLoading ? "CMS_loadingSpinner" : ""}>
                <div className="CMS_ls_spin" />
            </div>
        </div>
    );
};
